import * as yup from "yup";

const FileSize = 15000000;
const allowedFormats = [
  "image/jpeg",
  "image/png",
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export const masterResourceTableData = [
  {
    activity: "abc",
    name: "xyz",
    kind: "bbb",
    unit: "12",
  },
  {
    activity: "abc",
    name: "xyz",
    kind: "bbb",
    unit: "12",
  },
  {
    activity: "abc",
    name: "xyz",
    kind: "bbb",
    unit: "12",
  },
  {
    activity: "abc",
    name: "xyz",
    kind: "bbb",
    unit: "12",
  },
  {
    activity: "abc",
    name: "xyz",
    kind: "bbb",
    unit: "12",
  },
];

export const EventResourceConfig = [
  {
    id: 0,
    name: "",
    heading: "",
    fields: [
      {
        name: "incidentname",
        label: "incidentresourceformlabels.incidentname",
        type: "select",
        options: [],
      },
      {
        name: "eventdatetime",
        label: "incidentresourceformlabels.eventdatetime",
        type: "datetime",
        maxDate: new Date().toISOString().slice(0, 16),
      },
      {
        name: "latitude",
        label: "facilityformlabels.latitude",
        type: "input",
        disabled: true,
        col: 3,
      },
      {
        name: "longitude",
        label: "facilityformlabels.longitude",
        type: "input",
        disabled: true,
        col: 3,
      },

      {
        name: "eventDes",
        label: "incidentresourceformlabels.eventdes",
        type: "text_area",
        width: "50%",
      },
      {
        name: "uploafile",
        label: "incidentresourceformlabels.uploadfile",
        type: "multi_file_upload",
      },
    ],
  },
];

// Note: The validation schema is now generated dynamically in the component
// to have access to the current IncidentsData state

export const evetnresourcecolumnsForExport = [
  { label: "Incident Name", key: "incidentname" },
  { label: "Latitude", key: "latitude" },
  { label: "Longitude", key: "longitude" },
  { label: "Event Date & Time", key: "eventdatetime" },
  { label: "Event Des", key: "eventDes" },
  { label: "uploafile", key: "uploafile" },
];
